import { useEffect } from 'react';
import * as Tracker from '@lib/Tracker';

export const useTracker = () => {
  useEffect(() => {
    Tracker.init();
  }, []);
};
